//@flow
import * as Immutable from 'immutable';

import I18nHelper from 'common/helpers/I18nHelper';
import { GeocodeVerifiedGeometry } from 'common/models/flow/GeocodeVerifiedGeometry';
import { LatLng } from './LatLng';
import { Geometry } from './Geometry';
import { dashboardColors } from 'common/enums/ColorEnum';

import type { GeocodeVerifiedGeometryModelType } from 'common/models/flow/GeocodeVerifiedGeometry';
const translationsNamespace = ['translations'];

const nsTranslate = I18nHelper.getTranslate(translationsNamespace);

export const AccuracyCategoryType = {
    HIGHLY_ACCURATE: 'HIGHLY_ACCURATE',
    POSSIBLY_ACCURATE: 'POSSIBLY_ACCURATE',
    CANT_VERIFY: 'CANT_VERIFY',
    POSSIBLY_INACCURATE: 'POSSIBLY_INACCURATE',
    HIGHLY_INACCURATE: 'HIGHLY_INACCURATE'
};

const AccuracyCategoryTypeToConfidenceColorMap = {
    [AccuracyCategoryType.HIGHLY_ACCURATE]: dashboardColors.darkSkyBlue.name,
    [AccuracyCategoryType.POSSIBLY_ACCURATE]: dashboardColors.salmon.name,
    [AccuracyCategoryType.CANT_VERIFY]: dashboardColors.slate.name,
    [AccuracyCategoryType.POSSIBLY_INACCURATE]: dashboardColors.salmonTwo.name,
    [AccuracyCategoryType.HIGHLY_INACCURATE]: dashboardColors.salmonTwo.name
};

class InternalGeocodeVerifiedGeometry extends GeocodeVerifiedGeometry {
    static fromJS(
        json: GeocodeVerifiedGeometryModelType
    ): InternalGeocodeVerifiedGeometry {
        const state: Object = Object.assign({}, json);
        state.geocodedLatLng = state.geocodedLatLng
            ? LatLng.fromJS(state.geocodedLatLng)
            : state.geocodedLatLng;
        return new this(Immutable.Map(state));
    }

    get geocodedLatLng(): ?LatLng {
        return this._state.get('geocodedLatLng');
    }

    getAccuracyText(): string {
        const { accuracyCategory } = this;
        if (!this.accuracyCategory) {
            nsTranslate(
                `geocodeMap.accuracyCategory.${AccuracyCategoryType.CANT_VERIFY}`
            );
        }
        return nsTranslate(`geocodeMap.accuracyCategory.${accuracyCategory}`);
    }

    getAccuracyConfidenceColor(): string {
        return (
            AccuracyCategoryTypeToConfidenceColorMap[this.accuracyCategory] ||
            dashboardColors.slate
        );
    }
    hasGeocodedLatLng(): string {
        return this.geocodedLatLng && this.geocodedLatLng.isValid();
    }

    isDifferentLatLng(geometry: Geometry) {
        return geometry?.latLng?.isDifferent(this.geocodedLatLng);
    }
}

export { InternalGeocodeVerifiedGeometry as GeocodeVerifiedGeometry };
